// extracted by mini-css-extract-plugin
export default {"input":"NameInput_input__Kutll","invalid":"NameInput_invalid__fXGfQ"};